import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/imgs/logo.png'
import _imports_1 from '../../assets/imgs/menu.png'


const _withScopeId = n => (_pushScopeId("data-v-f765e4e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "lang-icon",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "#2c3e50",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "3.6",
    y1: "9",
    x2: "20.4",
    y2: "9"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "3.6",
    y1: "15",
    x2: "20.4",
    y2: "15"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M11.5 3a17 17 0 0 0 0 18" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12.5 3a17 17 0 0 1 0 18" })
], -1))

import useLocale from "@/hooks/useLocale"; // 国际化hook
import NavPopup from "@/components/Mobile/NavPopup.vue";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MbTheNav',
  setup(__props) {

const {
  i18n: { t }, // 解构实例用具t 访问语言变量
  changeLocale, // 修改国际化
} = useLocale();

// 是否关闭营销通知
const close_yingxiao = ref(true);

// 跳转到微信营销页面
const go_to_wx = () => {
  window.open("https://mp.weixin.qq.com/s/-S0JaF7lJHzZcUzicmT28A", "_blank");
};
// 切换语言
const drawer = ref(false);
function switchLang(lang: string) {
  changeLocale(lang);
  localStorage.setItem("lang", lang);
}
function handleMessage(e: boolean) {
  drawer.value = e;
}
function showTop() {
  drawer.value = !drawer.value;
}

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      onClick: go_to_wx,
      class: "the-yingxiao1"
    }, " 🔥" + _toDisplayString(_unref(t)("topBar.yingxiao1")), 513), [
      [_vShow, close_yingxiao.value]
    ]),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (close_yingxiao.value = false)),
      class: "the-close1"
    }, "x"),
    _createElementVNode("section", {
      class: "the-mbnav",
      style: _normalizeStyle(close_yingxiao.value ? '' : 'margin:0;')
    }, [
      _hoisted_1,
      _createElementVNode("div", { class: "el-dropdownlist" }, [
        _createElementVNode("img", {
          onClick: showTop,
          src: _imports_1,
          alt: ""
        })
      ]),
      _createVNode(_component_el_dropdown, { class: "el-dropdownlan" }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (switchLang('zh')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("简体中文")
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (switchLang('en')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("English")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ], 4),
    _createVNode(NavPopup, {
      showNavPopup: drawer.value,
      onCustomEvent: handleMessage
    }, null, 8, ["showNavPopup"])
  ], 64))
}
}

})